export const videoLessonRoute = [{
  path: 'video-lesson',
  component: () => import('../../../components/router-view'),
  children: [
    {
      path: '',
      name: 'VideoLessons',
      component: () => import('../../../components/Admin/VideoLesson'),
      meta: {
        access: ['admin', 'teacher', 'examiner']
      }
    },
    {
      path: 'create',
      name: 'CreateVideoLessons',
      component: () => import('../../../components/Admin/VideoLesson/create'),
      meta: {
        access: ['admin', 'teacher', 'examiner']
      }
    },
    {
      path: ':id',
      name: 'EditVideoLessons',
      component: () => import('../../../components/Admin/VideoLesson/edit'),
      meta: {
        access: ['admin', 'teacher', 'examiner']
      }
    }
  ]
}]



// WEBPACK FOOTER //
// /src/router/admin/module/videoLesson.js